import { registerComponent } from '@gig/magic-common';
import KeycloakUpdatePasswordComponent from './keycloak-update-password.vue.js';

var KeycloakUpdatePassword = registerComponent(KeycloakUpdatePasswordComponent);

export { KeycloakUpdatePassword };
